import {
  FileIcon,
  pn,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@compass/core";

import { ListBeProperty } from "components";
import { DataCenterFileListDto, DataCenterFileListResource, SortObject } from "generated/openApi";
import { useDateTime } from "hooks";
import { useNavigate } from "react-router-dom";
import { dataCenterFileViewPageRoute } from "../DataCenterFileViewPage/DataCenterFileViewPage";

export const DataCenterFileTable = (props: {
  tableContainerRef: React.RefObject<HTMLDivElement>;
  dataCenterFiles: DataCenterFileListDto[];
  resource: DataCenterFileListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const properties = props.resource.properties || [];
  const formatDateTime = useDateTime();

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell type="id">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<DataCenterFileListDto>("id"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<DataCenterFileListDto>("date"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<DataCenterFileListDto>("fileName"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<DataCenterFileListDto>("uploadedBy"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<DataCenterFileListDto>("status"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.dataCenterFiles.map((dataCenterFileItem) => (
            <TableRow
              key={dataCenterFileItem.id}
              onClick={() =>
                navigate(dataCenterFileViewPageRoute.getPath({ id: dataCenterFileItem.id, crudMode: "view" }))
              }
            >
              <TableCell type="id">{dataCenterFileItem.id}</TableCell>
              <TableCell>{formatDateTime(dataCenterFileItem.date)}</TableCell>
              <TableCell>
                <Stack direction="row" spacing="sm" alignItems="center">
                  {dataCenterFileItem.fileName && <FileIcon fileName={dataCenterFileItem.fileName} size="small" />}
                  <Typography variant="inherit">{dataCenterFileItem.fileName}</Typography>
                </Stack>
              </TableCell>
              <TableCell>{dataCenterFileItem.uploadedBy}</TableCell>
              <TableCell>
                <Typography
                  color={
                    dataCenterFileItem.status?.reactColor && theme.palette[dataCenterFileItem.status?.reactColor].main
                  }
                  sx={{ fontWeight: theme.typography.fontWeightBold }}
                >
                  {dataCenterFileItem.status?.name}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
